import { Toast } from 'vant'
import store from '@/store'
import { Dialog } from 'vant'

export function responseHandle(response) {
	switch (response.code) {
		case 10001:
			Dialog.confirm({
				title: '请先登录'
			}).then(() => {
				store.dispatch('user/loginOut')
			})
			break
		case 10000:
			Toast('本次请求错误，请稍后重试')
			break
		case 10003:
			Toast(response.msg)
			break
	}
}
